import { Component, Output, EventEmitter, OnInit, Inject, ViewChild, HostListener, AfterViewInit  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AffService } from '../../core/middleware-call/aff.service';
import { AffiliateSchemeResultModel } from '../../models/afffiliate-schemes-result-model';
import { ErrorHandlerService } from '../../error-handler.service';
import { SharedService } from '../../core/middleware-call/shared.service';
import { LoginService } from '../../core/middleware-call/login.service';
import { HeaderSharingService } from '../../core/services/header-sharing.service';
import { SidebarSharingService } from '../../core/services/sidebar-sharing.service';
import { saveAs } from 'file-saver/src/FileSaver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AvailableExercicesModel } from '../../models/available-exercices-model';
import { AffiliateDocModel } from '../../models/affiliate-doc-model';
import { PortfolioAccessibilityModel } from '../../models/portfolio-accessibility-model';
import { CompaniesModel } from '../../models/companies-model';
import { DatePipe } from '@angular/common';
import { CompanySchemeModel } from '../../models/company-scheme-model';
import { ToastrService } from 'ngx-toastr';
import { PortfolioService } from '../../core/middleware-call/portfolio.service';
import { FormGroup, FormControl } from '@angular/forms';
import { DocTypeModel } from '../../models/doc-type-model';
import { sidebarTransition } from '../../router.animations';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    animations: [sidebarTransition()]
})
export class SidebarComponent implements OnInit {
    public pipe = new DatePipe('fr');
    role: string;
    isActive: boolean;
    collapsed: boolean;
    showMenu: string;
    pushRightClass: string;

    editableAffiliateSchemes: AffiliateSchemeResultModel[] = [];  // still needed to display : beneficiaries / print certifs / view documents
    editableAffiliateSchemesSwitch: AffiliateSchemeResultModel[] = [];
    editableAffiliateSchemesRepartition: AffiliateSchemeResultModel[] = [];


    allAffiliateSchemes: AffiliateSchemeResultModel[] = [];
    currentPortfolioAccessibility: PortfolioAccessibilityModel = new PortfolioAccessibilityModel;
    hasChosenPlan: boolean = false;
    currentAffScheme: number = null;
    availableExercises: AvailableExercicesModel[]; // print certif content
    affDox: AffiliateDocModel[]; // view documents content
    companies: CompaniesModel[];
    companySchemeModel: CompanySchemeModel[];
    docTypes: DocTypeModel[]; // Used to store pension's doc types
    currentlyOpenedItemIndex: -1; // Used fo accordion stuff in template

    numberOfDocs: number[];

    @Output() collapsedEvent = new EventEmitter<boolean>();

    benefCertifCharInputRestNumber: number = 2000; // used to display  the remaining number of chars int he beneficiaries certif generaton popup input

    headerBarHeight: number; // adapts padding top if headerbar takes up more than 1 line
    // hide features in development
    devFeatureVisible: boolean = false;

    companyName: string;

    viewInit: boolean= true; // this prevents sidebar flashing when conditioned (like when entering a repartition from dashboard/overview)

    constructor(
        private modalService: NgbModal,
        private translate: TranslateService,
        private headerSharingService: HeaderSharingService,
        private sidebarSharingService: SidebarSharingService, // To make the sidebar update itself dynamically depending on different actions from the user
        public loginService: LoginService,
        private affService: AffService,
        private sharedService: SharedService,
        public router: Router,
        private toastr: ToastrService,
        public errorHandler: ErrorHandlerService,
        private portfolioService: PortfolioService, // only needed for nested loop to test if there are elements in the portfolio, otherwise switch is unavailable
        @Inject('BASE_URL') baseUrl: string) {

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });
    }

    ngOnInit() {
        // Sidebar settings
        this.isActive = false;
        this.collapsed = false;
        this.showMenu = '';
        this.pushRightClass = 'push-right';

        // Those functions subscribe to values from the HeaderSharingService and SidebarSharingService
        this.getHeaderSharingServiceRole().then(result => {
            this.getSidebarSharingServiceAffId().then(result => {
                this.getSidebarSharingServicePortfolioAccessibility();

                // We get affiliate schemes needed in the sidebar in order to let affiliates chose their plan
                if (this.role == "AFF") {
                    // If the affiliate has already chosen the plan he wants too work on, the sidebar will show buttons instead of dropdowns, so the user doesn't need to specify the plan he wants to be redirected to
                    this.getAffiliateSchemes();
                    console.log("hasChosenPlan " + this.hasChosenPlan);
                    console.log("currentAffScheme " + this.currentAffScheme);
                }
            });
        });


        console.log(sessionStorage.getItem('STORAGE_AFFID'));

        this.headerSharingService.getHeaderBarHeightAsObservable().subscribe(value => {
             this.headerBarHeight = value; // no need for timeout magic here
        });

        this.getCompanyName(); // this is the client company name as in hoster of the application company name (not the selected enterprise)

    }

      ngAfterViewInit() {
        setTimeout(() => {
            console.log("---ngAfterViewInit() Demo---");this.viewInit = true;
        });
      }

    //-------------------------------------------------------------------------------------\\
    //------------------------  Affiliate Part  -------------------------------------------\\
    //-------------------------------------------------------------------------------------\\

    /**
     * currentScheme and hasChosenPlan are subscribed to the SidebarSharingService
     * */
    getSidebarSharingServiceAffId() {
        return new Promise((resolve, reject) => {
            console.log("getSidebarSharingServiceAffId");
            this.sidebarSharingService.affId.subscribe(value => {
                this.currentAffScheme = value;
                console.log("We check the current scheme : " + value);
            });
            this.sidebarSharingService.hasChosenPlan.subscribe(value => {
                this.hasChosenPlan = value;
                console.log("We check if a plan has already been chosen");
            });
            resolve('OK');
        });

    }

    /**
     * currentPortfolioAccessibility is subscribed to the SidebarSharingService
     * */
    getSidebarSharingServicePortfolioAccessibility() {
        console.log("getSidebarSharingServicePortfolioAccessibility");
        this.sidebarSharingService.portfolioAccessibility.subscribe(value => {
            this.currentPortfolioAccessibility = value;
            console.log("We check currentPortfolioAccessibility : " + this.currentPortfolioAccessibility);
            console.log(this.currentPortfolioAccessibility);
        });
    }



    /**
     * Make role subscribe to the HeaderSharingService
     * */
    getHeaderSharingServiceRole() {
        console.log("getHeaderSharingServiceRole");
        return new Promise((resolve, reject) => {
            this.headerSharingService.role.subscribe(value => {
                this.role = value;
                console.log("We check what role currently is in navbar : " + this.role);
                resolve(true);
            });
        });
    }




    /**
    * When we enter the select plan page, we need to get the available plans for this user
    */
    getAffiliateSchemes() {

        // get faster result from memory of injected affService vars
        if (this.affService.isSidebarOptimizerUsable()) {
            console.log("SB optimizer");
            this.editableAffiliateSchemesSwitch = this.affService.getSwitchSchemes();
            this.editableAffiliateSchemesRepartition = this.affService.getRepartitionSchemes();
            this.allAffiliateSchemes = this.affService.getSchemes();
            console.log(this.allAffiliateSchemes);
            console.log(this.editableAffiliateSchemesSwitch);
            console.log(this.editableAffiliateSchemesRepartition);
        } else {
            console.log("SB init");

            // looks like this is the first load
            console.log("[2.7.20] entering getAffiliateSchemes");
            this.affService.getAffiliateSchemes().subscribe(result => {
                console.log("[2.7.20] getAffiliateSchemes result from call to mid obtained. length of result = "+result.length);
                for (let i = 0; i < result.length; i++) {
                    // The bellow commented code was used when we checked if portfolio was readonly to allow a user to access switch and repatition components
                    // But now the portfolio is set to readonly whenever a switch is ongoing (or maybe other reason ????) so we don't check that anymore but we blocked the access in the switch component itself
                    // TODO : Understand why it changed without obvious reason !
                    // UPDATE : PortfolioReadOnly == flase has been uncommented : the error came from  the fact that the data came from 2019 while we were in 2020, so all portfoio became automatically readonly
                    // NOTE FOR 2021 : Juste refresh the LO data, do not touch this code if the error ocuured at the beginning of a year4    gatherPortfolioDetailsPieData() {

                    console.log("[2.7.20] determining if scheme "+result[i].affId+" is to be added to the base collection (pfVisible && !pfRo is added)"+result[i].portfolioIsVisible+" "+result[i].portfolioIsReadOnly);
                    if(result[i].portfolioIsVisible==true&&result[i].portfolioIsReadOnly==false) {
                        console.log("[2.7.20] "+result[i].affId+" added to base collection");
                        this.editableAffiliateSchemes.push(result[i]); // needed to know what to display in : beneficiaries / print certifs / view documents


                        console.log("[2.7.20] determining if this scheme is to be added to the repartition collection (different then M is added)"+result[i].affiliateStatus);
                        if(result[i].affiliateStatus!="M") {
                            console.log("[2.7.20] "+result[i].affId+" added to repartition collection");
                            this.editableAffiliateSchemesRepartition.push(result[i]); // needed to know what to display in : Repartition (if its maintainance status then there is no point in doing a repartiton)
                        } else {
                                console.log("[2.7.20] "+result[i].affId+" NOT added to repartition collection");
                        }

                        console.log("[2.7.20] determining if this scheme is to be added to the switch collection "+result[i].affId);
                        this.portfolioService.getNonNullPortfolioDetailsArrayForAffId(result[i].affId).subscribe(result2 => {
                            console.log("[2.7.20] "+result2 + " received " + result2.length);
                            if(result2.length>0) {
                                console.log("[2.7.20] "+result[i].affId+" added to switch collection");
                                this.editableAffiliateSchemesSwitch.push(result[i]); // needed to know what to display in : Switch. (no acces if no elements are in portfolio, there is no backend svc to give a bool)
                            } else {
                                console.log("[2.7.20] "+result[i].affId+" NOT added to switch collection");
                            }
                        },error => {
                        });

                    }

                    // old version without check for elements in portfolio
                    //if (result[i].portfolioIsVisible == true && result[i].portfolioIsReadOnly == false) {
                    //    this.editableAffiliateSchemes.push(result[i]);
                    //}
                    this.allAffiliateSchemes.push(result[i]);
                }
                console.log("this.editableAffiliateSchemes");
                console.log(this.editableAffiliateSchemes);
            }, error => {
                console.error(error);
                console.error(error.status);
                this.errorHandler.handleError(error);

            });
            this.affService.setSchemes(this.allAffiliateSchemes);
            this.affService.setSwitchSchemes(this.editableAffiliateSchemesSwitch);
            this.affService.setRepartitionSchemes(this.editableAffiliateSchemesRepartition);
        }
    }

    /**
    * When a scheme gets selected we communicate the affId of the selected scheme to the mid so it can be set into session vars
    */
    setAffiliateScheme(affId) {

        sessionStorage.setItem("STORAGE_AFFID", affId); // [BRANCH JKA] - remove all the stuff below
        localStorage.setItem("STORAGE_AFFID", affId); // Test to prevent savage reloads

        // Set the current scheme name to be displayed in Header bar
        for (let i = 0; i < this.allAffiliateSchemes.length; i++) {
            if (affId == this.allAffiliateSchemes[i].affId) {
                sessionStorage.setItem("STORAGE_SCHNAME", this.allAffiliateSchemes[i].schName);
                console.log("[[[[[[[[[[[ Putting CieName into SessionStorage through sidebar :"+this.allAffiliateSchemes[i].cieName);
                sessionStorage.setItem("STORAGE_CIENAME", this.allAffiliateSchemes[i].cieName);
                this.sidebarSharingService.setSchName(this.allAffiliateSchemes[i].schName);
                this.sidebarSharingService.setCieName(this.allAffiliateSchemes[i].cieName);
            }
        }
        return new Promise((resolve, reject) => {

            this.sharedService.setCurrentAffiliateScheme(affId).subscribe(result => {
                console.log(result);
                resolve('OK');
            }, error => {
                console.error(error);
                console.error(error.status);
                if (error.status == 500) {
                    console.error("handle 500");
                    this.errorHandler.handleError(error);
                }
                resolve('NOK');
            });

        });
    }


    /**
     * Redirect the affiliate to to switch part of the chosen plan 
     */
    goToSwitch(affId) {
        this.setAffiliateScheme(affId).then(res => {
            this.sidebarSharingService.setAffId(affId);
        });
        this.router.navigate(['/affiliate/switchRules']);
    }

    // Redirect the affiliate to to invest. policy part of the chosen plan
    goToRepartition(affId) {
        this.setAffiliateScheme(affId).then(res => {
            this.sidebarSharingService.setAffId(affId);
        });
        this.router.navigate(['/affiliate/repartitionRules']);
    }

    /////////////////////////
    // Beneficiaries part  //
    /////////////////////////

    // Triggered by the corresponding button to open the beneficiaries modal
    triggerBeneficiaries(schId, content) {
        this.setAffiliateScheme(schId).then(res => {
            this.openVerticallyCentered(content);
        });
    }

    triggerAccountStatement(affId) {
        this.toastr.success('',this.translate.instant('TS_Document_Generation_Started_Toast'));
        this.affService.generateAccountStatement(Number(affId)).subscribe(
            result => {
                saveAs(result, this.translate.instant('TS_AccountStatement')+"_"+affId+'.pdf');
                console.log(result);
            },
            error => {
                this.toastr.warning('',this.translate.instant('TS_Document_Generation_Failed_Toast'));
                console.error("error on callback GenerateAccountStatement");
                console.error(error);
            }
        );
    }

    //
    updateBenefCertifCharInputRestNumber(nbr) {
        console.log("triggered");
        this.benefCertifCharInputRestNumber = 2000 - nbr;
    }

    /**
     * Triggered by the beneficiaries modal to generate a pdf
     */
    generateBeneficiariesPdf(clause: string) {
        console.log("This ng service should probably be moved from shared to affiliate " + clause);
        this.modalService.dismissAll();
        this.sharedService.getBeneficiaryCertificatFromStream(clause).subscribe((data) => {
            saveAs(data, this.translate.instant('TS_Beneficiaries_Certif_File_Name') + "_" + ''); // should not need the .pdf at the end as it's most certainly included via mid/backend
        }, error => {
            console.error(error);
            this.toastr.warning('', this.translate.instant('TS_Document_Generation_Fail_Toast'));
        });
        this.closeModal();
    }



    //---------------------\\
    //  Print certif part  \\
    //---------------------\\

    /**
     * MW call to get exercices to display in the modal
     */
    getICAvailableExercices() {
        return new Promise((resolve, reject) => {
            this.sharedService.getICAvailableExercices().subscribe(result => {
                console.log("getICAvailableExercices");
                console.log(result);
                this.availableExercises = result;
                resolve('OK');

            }, error => {
                console.error(error);
                console.error(error.status);
                if (error.status == 500) {
                    console.error("[3]  GetAffiliateDocuments handle 500");
                    this.errorHandler.handleError(error);
                }
                resolve('NOK');
            });
        });
    }

    // Function called by a button to open a modal with data in it
    openAvailableExercices(schId, content) {
        // make the data call
        this.setAffiliateScheme(schId).then(res => {
            this.getICAvailableExercices().then(res => {
                console.log("[availableExercises] then part ,res = " + res);
                // then open the modal
                this.openVerticallyCentered(content);
            });
        });
    }

    // Function called when clicking on an exercice in the modal to download a pdf
    getExerciseContent(exeId) {
        this.toastr.success('', this.translate.instant('TS_Document_Generation_Started_Toast'));
        console.log("getExerciseContent with exeId:" + exeId);
        this.modalService.dismissAll();
        this.sharedService.getExoFromStream(exeId).subscribe((data) => {
            saveAs(data, this.translate.instant('TS_Certificat') + "_" +exeId+ "_" + sessionStorage.getItem("STORAGE_AFFID")+'.pdf');
        }, error => {
            console.error(error);
            this.toastr.warning('', this.translate.instant('TS_Document_Generation_Fail_Toast'));
        });
    }


    //------------------------\\
    // View pension docs part \\
    //------------------------\\

    // Function called by the button to open the modal with data in it
    openPensionDocsModal(schId, content) {

        this.setAffiliateScheme(schId).then(res => {
            this.getDocumentTypes().then(result => {
                this.getAffiliateDocuments().then(res => {
                    console.log("[getAffiliateDocuments] then part ,res = " + res);
                    this.openVerticallyCentered(content);
                    this.determinDocsPerDctId(this.affDox);
                })
            });
        });
    }

    getDocumentTypes() {
        return new Promise((resolve, reject) => {
            this.sharedService.getDocumentTypes().subscribe(
                result => {
                    console.log("result of getDocumentTypes :");
                    console.log(result);
                    this.docTypes = result;
                    console.log(this.docTypes);
                    //console.log("numbr of getDocumentTypes :"+this.numberOfDocTypes);
                    resolve('OK');
                },
                error => {
                    console.error("error on callback getDocumentTypes");
                    console.error(error);
                    this.errorHandler.handleError(error);
                    //resolve('NOK');
                });
        });
    }

    // MW call to get documents to display in the modal
    getAffiliateDocuments() {
        return new Promise((resolve, reject) => {
            this.sharedService.getAffiliateDocuments().subscribe(result => {
                console.log(result);

                this.affDox = result;


                //this.numberOfDocs = [0, 0, 0, 0, 0, 0, 0, 0]; // old hardcoded bad version

                this.numberOfDocs = new Array(this.docTypes.length); // collection counter for doc indexer
                for (let a = 0; a<this.numberOfDocs.length ; a++){
                    this.numberOfDocs[a] = 0; // ini all at zero
                }

                resolve('OK');

            }, error => {
                console.error(error);
                console.error(error.status);
                if (error.status == 500) {
                    console.error("[3]  GetAffiliateDocuments handle 500");
                    this.errorHandler.handleError(error);
                }
                resolve('NOK');
            });
        });

    }


    // Function called when clicking on a doc in the modal to download it as a pdf
    getDocumentContent(bobId, fileName) {
        console.log("getDocumentContent with bobid:" + bobId + " and filename : " + fileName);
        this.toastr.success('', this.translate.instant('TS_Document_Generation_Started_Toast'));
        this.modalService.dismissAll();
        this.sharedService.getFileFromStream(bobId).subscribe((data) => {
            saveAs(data, fileName + '');
        }, error => {
            console.error(error);
            this.toastr.warning('', this.translate.instant('TS_Document_Generation_Fail_Toast'));
        });
    }

    determinDocsPerDctId(allAffDox) {
        // looping through affdox and determining what array slot to increment depending on dctId
        for (let i = 0; i < allAffDox.length; i++) {
            // note cat amazon are 1,2,5,6,7,9,10,12,13,14,15,16,17 also loops have a habit of starting at 0 (so -1 to dctId and -3 if bigger than 3)
            for(let t = 0 ; t < this.docTypes.length ; t++){
                if (allAffDox[i].dctId == this.docTypes[t].dctId){
                    //console.log("Found doc n#"+i+" with dctId "+allAffDox[i].dctId+" to be equal to type "+t+" ("+t+":"+this.docTypes[t].dctId+") incrementing space t on numberOfDocs from "+this.numberOfDocs[t]);
                    this.numberOfDocs[t] = this.numberOfDocs[t] + 1; // incrementing the same spot as this doc types iteration value 't', as both arrays should reflect the dctId value, independantly of gaps etc
                }
            }
        }
    }
            
            
        
        
                


    //------------\\
    // Popup part \\
    //------------\\

    openVerticallyCentered(content) {
        this.closeModal().then(res => {
            this.modalService.open(content, { centered: true, size: 'lg', backdrop: true, keyboard: true });
        });
    }

    closeModal() {
        return new Promise((resolve, reject) => {
            this.modalService.dismissAll();
            resolve('OK');
        });
    }

    // ---------------------------------------------------------------------------------- \\
    // Sidebar functions part
    // ---------------------------------------------------------------------------------- \\

    eventCalled() {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }

    openSidebar() {
        this.collapsed = false;
        this.collapsedEvent.emit(this.collapsed);

    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.collapsedEvent.emit(this.collapsed);
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }


    // Change langue
    changeLang(language: string) {
        this.translate.use(language);
    }


    // Functions regarding accordion in template 
    setOpened(itemIndex) {
        this.currentlyOpenedItemIndex = itemIndex;
    }

    setClosed(itemIndex) {
        if (this.currentlyOpenedItemIndex === itemIndex) {
            this.currentlyOpenedItemIndex = -1;
        }
    }




    getCompanyName() {
        return new Promise((resolve,reject) => {
            console.log("getCompanyName triggered");
            this.sharedService.getCompanyName().subscribe(result => {
                this.companyName=result.companyName;
                resolve("OK")
            },error => {
                console.error("error on callback isPortfolioRepartitionEnabled");
                console.error(error);
                this.companyName="";
                resolve("NOK");
            })
        });
    }




}
